export enum SocialMediaType {
  INSTAGRAM = 'INSTAGRAM',
  FACEBOOK = 'FACEBOOK',
  TIKTOK = 'TIKTOK',
  YOUTUBE = 'YOUTUBE',
  LINKEDIN = 'LINKEDIN',
  WHATSAPP = 'WHATSAPP',
  VIBER = 'VIBER',
  TELEGRAM = 'TELEGRAM',
  X = 'X',
  CUSTOM = 'CUSTOM',
}

export namespace SocialMediaType {
  export function getAll(): SocialMediaType[] {
    return [
      SocialMediaType.INSTAGRAM,
      SocialMediaType.FACEBOOK,
      SocialMediaType.TIKTOK,
      SocialMediaType.YOUTUBE,
      SocialMediaType.LINKEDIN,
      SocialMediaType.WHATSAPP,
      SocialMediaType.VIBER,
      SocialMediaType.TELEGRAM,
      SocialMediaType.X,
    ];
  }

  export function getIcon(type?: SocialMediaType): string {
    switch (type) {
      case SocialMediaType.INSTAGRAM:
        return 'fa-instagram';
      case SocialMediaType.FACEBOOK:
        return 'fa-facebook';
      case SocialMediaType.TIKTOK:
        return 'fa-tiktok';
      case SocialMediaType.YOUTUBE:
        return 'fa-youtube';
      case SocialMediaType.LINKEDIN:
        return 'fa-linkedin-in';
      case SocialMediaType.WHATSAPP:
        return 'fa-whatsapp';
      case SocialMediaType.VIBER:
        return 'fa-viber';
      case SocialMediaType.TELEGRAM:
        return 'fa-telegram';
      case SocialMediaType.X:
        return 'fa-x';
      default:
        return '';
    }
  }

  export function getDisplayName(type?: SocialMediaType): string {
    switch (type) {
      case SocialMediaType.INSTAGRAM:
        return 'Instagram';
      case SocialMediaType.FACEBOOK:
        return 'Facebook';
      case SocialMediaType.TIKTOK:
        return 'TikTok';
      case SocialMediaType.YOUTUBE:
        return 'YouTube';
      case SocialMediaType.LINKEDIN:
        return 'LinkedIn';
      case SocialMediaType.WHATSAPP:
        return 'WhatsApp';
      case SocialMediaType.VIBER:
        return 'Viber';
      case SocialMediaType.TELEGRAM:
        return 'Telegram';
      case SocialMediaType.X:
        return 'X';
      default:
        return '';
    }
  }
}
